import {wrapWithApolloProvider} from './src/wrapWithApolloProvider';
export const wrapRootElement = wrapWithApolloProvider;
